"use client";

import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface UnreadCountState {
    announcement: number;
    system: number;
    total: number;
    setUnreadCount: ( data: { announcement: number; system: number; total: number } ) => void;
}

export const useUnreadCount = create<UnreadCountState>()(
    devtools(
        ( set ) => ( {
            announcement: 0,
            system: 0,
            total: 0,
            setUnreadCount: ( data ) => set( data ),
        } ),
        {
            name: "UnreadCount",
            enabled: process.env.NODE_ENV === "development",
        },
    ),
);
